import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import BrokerLogo from "./BrokerLogo";
import { getBrokerId } from "../../../service/api/BrokerAccountApi";
import "./Brokers.css";

const maskClientId = (value = "") =>
  value.length > 4 ? `${value.slice(0, 4)}${"*".repeat(Math.min(value.length - 4, 6))}` : value;

const getBrokerType = (broker) =>
  broker.brokerType === "DHAN" ? "dhan" : broker.brokerType === "FYERS" ? "fyers" : "angel";

const getBrokerName = (broker) =>
  broker.brokerType === "DHAN" ? "Dhan" : broker.brokerType === "FYERS" ? "Fyers" : "Angel One";

const BrokerSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const broker = location.state?.broker;

  if (!broker) return <Navigate to="/brokers" replace />;

  return (
    <main className="broker-page broker-result-page">
      <section className="broker-result-card">
        <div className="broker-success-mark">
          <i className="fa fa-check" aria-hidden="true"></i>
        </div>
        <h1>Broker Connected Successfully!</h1>
        <p>Your broker account has been connected and is ready for algo trading.</p>

        <div className="broker-result-summary">
          <div className="broker-result-summary__broker">
            <BrokerLogo type={getBrokerType(broker)} />
            <strong>{getBrokerName(broker)}</strong>
          </div>
          <dl>
            <div><dt>Account Name</dt><dd>{broker.accountName}</dd></div>
            <div><dt>Client ID</dt><dd>{maskClientId(broker.clientId || broker.clientCode)}</dd></div>
            <div><dt>Status</dt><dd>{broker.status || "Pending verification"}</dd></div>
          </dl>
        </div>

        <div className="broker-result-actions">
          {getBrokerId(broker) && (
            <button className="broker-secondary-button" onClick={() => navigate(`/brokers/${getBrokerId(broker)}`)}>
              View Details
            </button>
          )}
          <button className="broker-primary-button" onClick={() => navigate("/brokers")}>
            Go to My Brokers
            <i className="fa fa-arrow-right" aria-hidden="true"></i>
          </button>
        </div>
      </section>
    </main>
  );
};

export default BrokerSuccess;
